import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MaterialUnitType } from "../../Types/HeyTraderTypes/Materials/MaterialUnitType";
import { getAllMaterialUnitList } from "../../Thunks/HeyTraderThunks";

interface MaterialUnitSliceState {
    loader: boolean; // for refres pages and inital loadings
    materialUnitList: MaterialUnitType[];
    errorDisplay: string | null;
}
// set inital valus
const initialState : MaterialUnitSliceState = {
    loader: false,
    materialUnitList: [],
    errorDisplay: '',
}

// set state valu for api response
const materialUnitSlice = createSlice ({
    name: 'materialUnit',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllMaterialUnitList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllMaterialUnitList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllMaterialUnitList.fulfilled, (state, action: PayloadAction<MaterialUnitType[]>) => {
                    state.loader = false;
                    state.materialUnitList = action.payload;
                  })
    }
})

export const {} = materialUnitSlice.actions
export default materialUnitSlice.reducer
